import {useLogger, useUniversalFetch} from '#imports';

async function useGetContent(humanId: string, locale: string, type: string): Promise<string | undefined> {
    const logger = useLogger();
    const endpoint = '/api/content';

    let result;
    try {
        result = await useUniversalFetch<string>(endpoint, {
            query: {
                humanId,
                locale,
                type,
            },
        });
    } catch (e: unknown) {
        logger.error(`Error while getting content with parameters ${humanId}, ${locale}, ${type}: ${e instanceof Error ? e.message : undefined}`);
    }
    return result;
}

async function useGetLastVersionForContent(humanId: string, locale: string, type: string): Promise<string | undefined> {
    const logger = useLogger();
    const endpoint = '/api/content/versions/last';

    let result;
    try {
        result = await useUniversalFetch<string>(endpoint, {
            query: {
                humanId,
                locale,
                type,
            },
        });
    } catch (e: unknown) {
        logger.error(`Error while getting content with parameters ${humanId}, ${locale}, ${type}: ${e instanceof Error ? e.message : undefined}`);
    }
    return result;
}

function createContentApi() {
    return {
        getContent: useGetContent,
        getLastVersionForContent: useGetLastVersionForContent,
    };
}

export {createContentApi as useContent};
